// =============================================================================
// Copyright   : 2024 semantics GmbH
// Date        : $Date: 2026-06-18 18:06:52 +0200 (Thu, 18 Jun 2026) $
// Author      : Dirk Rothe, Tobias Schwarzkopf
// Worker      : $Author: o.powroznik $
// Revision    : $Rev: 163867 $
// Purpose     : i18n hooks
// =============================================================================
// ---Third-party imports
// ---Framework imports
import { Actions, Sel } from 'uix/registries';
import { useSelector, useActions } from 'uix/hooks';
export const useLanguageSwitching = ()=>{
    let dconfig = useSelector(Sel.dconfig);
    let switchLanguage = useActions(Actions.switchLanguage);
    let selected = useSelector((root)=>root.meta.language);
    return {
        supported: dconfig.language.supported,
        selected,
        auxiliary: dconfig.language.auxiliary,
        switchLanguage
    };
};
